import { useNavigate } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';
import { useAuthStore } from '../../../stores/authStore';
import { useSettings } from '../../../hooks/useSettings';
import { palette, admin, transition, fontFamily } from '../../../styles/tokens';
import { ModulesSection } from '../../../components/settings/ModulesSection';
import { VocabularySection } from '../../../components/settings/VocabularySection';
import { SettingsSubPage } from '../components/SettingsSubPage';
import { Skeleton } from '../../../components/common/Skeleton';

export function TeamRolesPage() {
  const navigate = useNavigate();
  const authBusiness = useAuthStore(s => s.business);
  const { business, teamCounts, loading, updateBusiness } = useSettings(authBusiness?.id);

  return (
    <SettingsSubPage title="Team & roles" description="Permissions, commission rules, operator config">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {/* Team overview card */}
        <div style={{
          background: palette.white,
          borderRadius: admin.cardRadius,
          border: `1px solid ${admin.border}`,
          overflow: 'hidden',
        }}>
          <div style={{
            padding: '14px 20px',
            borderBottom: `1px solid ${palette.g100}`,
            fontSize: 14,
            fontWeight: 600,
            color: palette.g800,
          }}>
            Team overview
          </div>
          <div style={{ padding: '16px 20px' }}>
            {loading ? (
              <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                {[0, 1, 2, 3].map(i => (
                  <div key={i}>
                    <Skeleton width={36} height={22} style={{ marginBottom: 6 }} />
                    <Skeleton width={64} height={11} />
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                {[
                  { label: 'Total', value: teamCounts.total },
                  { label: 'Employees', value: teamCounts.employees },
                  { label: 'Contractors', value: teamCounts.contractors },
                  { label: 'Operators', value: teamCounts.operators },
                ].map(item => (
                  <div key={item.label}>
                    <div style={{ fontSize: 20, fontWeight: 600, color: palette.g800 }}>{item.value}</div>
                    <div style={{ fontSize: 12, color: palette.g500, marginTop: 2 }}>{item.label}</div>
                  </div>
                ))}
              </div>
            )}
            <button
              onClick={() => navigate('/team')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                marginTop: 16,
                padding: '8px 16px',
                borderRadius: 8,
                border: `1px solid ${admin.border}`,
                background: palette.white,
                fontSize: 13,
                fontWeight: 500,
                color: palette.g600,
                cursor: 'pointer',
                fontFamily,
                transition: `border-color ${transition.fast}`,
              }}
            >
              <Users size={14} strokeWidth={1.8} />
              Manage team
              <ArrowRight size={12} />
            </button>
          </div>
        </div>

        {/* Modules section */}
        {business && (
          <ModulesSection modulesEnabled={business.modules_enabled ?? []} tier={business.tier} />
        )}

        {/* Vocabulary section */}
        {business && (
          <VocabularySection vocabulary={business.vocabulary ?? {}} onSave={updateBusiness} />
        )}
      </div>
    </SettingsSubPage>
  );
}
